import React, { memo } from 'react';
import './index.scss';
const PageHeading = ({ text, className }) => (
  <h1 className={`page-heading ${className || ''}`}>{text}</h1>
);

export default memo(PageHeading);
